import { createSlice } from '@reduxjs/toolkit';

/**
 * @typedef {import('@reduxjs/toolkit').PayloadAction} PayloadAction
 * @typedef {import('../../index.d.ts').ModalSheetState} ModalSheetState
 */
const modalSheetSlice = createSlice({
  name: 'modalSheet',
  /**
   * @type {ModalSheetState}
   */
  initialState: {
    type: null,
    props: {},
  },
  reducers: {
    hideModal(state) {
      state.type = null;
      state.props = {};
    },
    /**
     *
     * @param state
     * @param {PayloadAction<ModalSheetState>} payload
     */
    dispatchModal(state, { payload }) {
      state.type = payload.type;
      state.props = payload.props;
    },
  },
});

export default modalSheetSlice;
export const { hideModal, dispatchModal } = modalSheetSlice.actions;
